import moment from 'moment/moment';

export default function (app) {
  app.controller('klCustomerCenterBuyCtrl', [
    '$scope',
    '$state',
    '$window',
    'klNotificationService',
    'klAccountService',
    'klRatePlanService',
    'klConfigService',
    'klSubscriptionService',
    function (
      $scope,
      $state,
      $window,
      NotificationService,
      AccountService,
      RatePlanService,
      ConfigService,
      SubscriptionService,
    ) {
      this.isLoading = true;
      this.addressFormInvalid = false;
      this.hasError = false;
      this.errorMessage = null;
      this._config = null;
      this.account = {};
      this.subscriptionPreviewPeriods = ['Annual'];
      this.newAccount = $state.params.params.newAccount;
      this.accountId = $state.params.params.accountId;
      this.licenseId = $state.params.params.licenseId;
      this.accountName = $state.params.params.accountName;
      this.accountNumber = $state.params.params.accountNumber;
      this.licenseKey = $state.params.params.licenseKey;
      this.availableProductRatePlans = $state.params.params.availableProductRatePlans;
      this.defaultProductRatePlan = $state.params.params.defaultProductRatePlan;
      this.resellerStatus = $state.params.params.resellerStatus;
      this.isNewKey = $state.params.params.isNewKey;
      this.nextYear = moment().add(1, 'years').format('MMM Do YYYY');
      this.nextMonth = moment().add(1, 'month').format('MMM Do YYYY');
      this.nextTerm = this.nextYear;
      this.selectedProductRatePlan = this.defaultProductRatePlan;
      this.product = { name: '', unitPrice: 0, seats: 1, term: '', netto: 0 };
      this.discount = { name: '', percentage: 0, term: '', netto: 0 };
      this.total = { netto: 0, brutto: 0, tax: 0 };
      this.renewalProduct = { name: '', unitPrice: 0, seats: 0, term: '', netto: 0 };
      this.renewalDiscount = { name: '', percentage: 0, term: '', netto: 0 };
      this.renewalTotal = { netto: 0, brutto: 0, tax: 0 };
      this.successRedirection = false;
      this.subscription = {};
      this.subscription.PurchaseOrderNumber__c = null;

      this.getDiscountProductRatePlans = function (productRatePlan) {
        const discountProductRatePlans = [];
        this._config.productRatePlans_ResellerDiscount.forEach((prp) => {
          if (productRatePlan.term == prp.term && prp.resellerStatus == this.resellerStatus) {
            discountProductRatePlans.push(prp);
          }
        });
        return discountProductRatePlans;
      };

      this.getSelectedProductRatePlanIndex = function () {
        let index = -1;
        let resultingIndex = -1;
        this.availableProductRatePlans.forEach((productRatePlan) => {
          index = index + 1;
          if (productRatePlan.id == this.selectedProductRatePlan.id) {
            resultingIndex = index;
          }
        });
        return resultingIndex;
      };

      this.getUpdatedBill = function (productRatePlan, qty, nTerm) {
        const discountProductRatePlans = this.getDiscountProductRatePlans(productRatePlan);
        const productRatePlanIds = [productRatePlan.id];
        discountProductRatePlans.forEach((discountProductRatePlan) => {
          if (discountProductRatePlan.nTerm == nTerm) {
            productRatePlanIds.push(discountProductRatePlan.id);
          }
        });
        return this.getRatePlanPeriodBill(productRatePlanIds, qty);
      };

      this.updateRatePlan = function (productRatePlan) {
        this.isLoading = true;
        Promise.all([
          this.getUpdatedBill(productRatePlan, 1, 'first').then((response) => {
            this.bill = response.bill;
            this.subscriptionPreviewPeriods = [this.bill[0].period];
            this.nextTerm =
              this.subscriptionPreviewPeriods[0] == 'Annual' ? this.nextYear : this.nextMonth;
          }),
          this.getUpdatedBill(productRatePlan, 1, 'all').then((response) => {
            this.renewalBill = response.bill;
          }),
        ])
          .catch((e) => {
            this.handleError(e);
          })
          .then(() => {
            this.updatePrice();
            this.isLoading = false;
            $scope.$apply();
          });
      };

      ConfigService.getConfig().then((config) => {
        this._config = config;
        this.updateRatePlan(this.selectedProductRatePlan);
      });

      this.selectedProductRatePlanChanged = function (selectedProductRatePlan) {
        if (selectedProductRatePlan.id == this.selectedProductRatePlan.id) {
          return;
        }
        this.selectedProductRatePlan.id = selectedProductRatePlan.id;
        this.selectedProductRatePlan.name = selectedProductRatePlan.name;
        this.selectedProductRatePlan.term = selectedProductRatePlan.term;
        this.updateRatePlan(selectedProductRatePlan);
      };

      this.getBill = function (periods, ratePlans) {
        const bill = [];
        periods.forEach(function (period) {
          const section = {
            period,
            ratePlans: [],
            price: {
              brutto: 0,
              netto: 0,
              tax: 0,
            },
          };
          ratePlans.forEach(function (ratePlanItem) {
            const price = ratePlanItem.prices[period];
            if (price) {
              section.price.brutto += parseFloat(price.brutto.toFixed(2));
              section.price.netto += parseFloat(price.netto.toFixed(2));
              section.price.tax += parseFloat(price.tax.toFixed(2));
              section.ratePlans.push({
                ratePlan: ratePlanItem.ratePlan,
                price: price,
                quantity: ratePlanItem.quantity,
              });
            }
          });
          bill.push(section);
        });
        return bill;
      };

      this.getRatePlanPeriodBill = function (ratePlanIds, quantity) {
        const promises = [];
        for (const ratePlanId of ratePlanIds) {
          promises.push(
            RatePlanService.getRatePlan(ratePlanId)
              .then((ratePlan) => {
                if (!ratePlan) {
                  return Promise.reject(
                    `Couldn't retrieve ratePlan from ratePlanId: ''${ratePlanId}'`,
                  );
                }
                return { ratePlan, quantity };
              })
              .then(RatePlanService.addDefaultQuantity),
          );
        }
        return Promise.all(promises)
          .then((ratePlans) =>
            RatePlanService.calculatePrices(ratePlans, AccountService.getPreviewAccount()),
          )
          .then(RatePlanService.decorateRatePlans)
          .then((ratePlans) => {
            {
              const periods = RatePlanService.getBillingPeriods(ratePlans);
              const bill = this.getBill(periods, ratePlans);
              return { ratePlans: ratePlans, periods: periods, bill: bill };
            }
          });
      };

      this.updatePrice = function () {
        if (!this.bill[0].ratePlans[0].price.netto || this.bill[0].ratePlans[0].price.netto == 0) {
          const e = new Error('invalid product price');
          this.handleError(e);
          throw e;
        }

        //product
        this.product.name = this.bill[0].ratePlans[0].ratePlan.productRatePlanCharges[0].name;
        this.product.unitPrice = this.bill[0].ratePlans[0].price.netto.toFixed(2);
        this.product.netto = (this.product.unitPrice * this.product.seats).toFixed(2);
        this.renewalProduct = JSON.parse(JSON.stringify(this.product));

        //discount
        if (this.bill[0].ratePlans[1]) {
          this.discount.name =
            [this.bill[0].period] == 'Annual' ? 'First Year Discount' : 'First Month Discount';
          this.discount.netto = (
            this.bill[0].ratePlans[1].price.netto * this.product.seats
          ).toFixed(2);
          this.discount.percentage = ((-this.discount.netto / this.product.netto) * 100).toFixed(0);
        } else {
          this.discount = null;
        }
        if (this.renewalBill[0].ratePlans[1]) {
          this.renewalDiscount.name =
            this.renewalBill[0].ratePlans[1].ratePlan.productRatePlanCharges[0].name;
          this.renewalDiscount.netto = (
            this.renewalBill[0].ratePlans[1].price.netto * this.product.seats
          ).toFixed(2);
          this.renewalDiscount.percentage = (
            (-this.renewalDiscount.netto / this.renewalProduct.netto) *
            100
          ).toFixed(0);
        } else {
          this.renewalDiscount = null;
        }

        //total
        this.total.netto = (this.bill[0].price.netto * this.product.seats).toFixed(2);
        this.total.tax = (this.bill[0].price.tax * this.product.seats).toFixed(2);
        this.total.brutto = (this.bill[0].price.brutto * this.product.seats).toFixed(2);
        this.renewalTotal.netto = (this.renewalBill[0].price.netto * this.product.seats).toFixed(2);
        this.renewalTotal.tax = (this.renewalBill[0].price.tax * this.product.seats).toFixed(2);
        this.renewalTotal.brutto = (this.renewalBill[0].price.brutto * this.product.seats).toFixed(
          2,
        );
      };

      this.changeQuantity = function () {
        this.updatePrice();
      };

      this.increaseQuantity = function () {
        this.product.seats += 1;
        this.updatePrice();
      };

      this.canDecreaseQuantity = function () {
        return this.product.seats > 1;
      };

      this.decreaseQuantity = function () {
        if (this.canDecreaseQuantity()) {
          this.product.seats -= 1;
          this.updatePrice();
        }
      };

      this.abort = function () {
        $state.go('^');
      };

      this.handleError = function (e) {
        this.errorMessage = e;
        console.error(e);
        this.hasError = true;
        this.isLoading = false;
        $scope.$apply();
      };

      this.confirmCreateBuy = function (isValid) {
        this.isLoading = true;
        this.account.isNew = this.newAccount;
        if (!isValid) {
          this.addressFormInvalid = true;
          this.isLoading = false;
          return NotificationService.putError('auth', 'error_required_fields');
        }
        if (this.account.billToContact.country === 'US') {
          this.account.billToContact.zipCode = this.account.billToContact.zipCode.replace(
            /\D/g,
            '',
          );
        }
        AccountService.verifyAddress(this.account)
          .then((response) => {
            if (!response || !response.data || response.data.isAddressVerified != true) {
              this.addressFormInvalid = true;
              NotificationService.putError(
                'auth',
                "We couldn't verifiy this Address. Please check for Typos!",
              );
              throw 'Invalid Address';
            } else {
              this.account.currency = AccountService.getCurrency();
              this.account.isNew = true;
              this.account.resellerAccountId = AccountService.getAccount().id;
              return this.getUpdatedBill(
                this.selectedProductRatePlan,
                this.product.seats,
                'first',
              ).then((response) => {
                SubscriptionService.subscribe(
                  response.bill[0].ratePlans,
                  this.account,
                  null,
                  null,
                  {},
                  this.licenseId,
                  this.subscription.PurchaseOrderNumber__c,
                )
                  .then(() => {
                    this.successRedirection = true;
                  })
                  .catch((e) => this.handleError());
              });
            }
          })
          .then(() => {
            setTimeout(function () {
              this.isLoading = false;
              $window.location.reload();
            }, 7500);
          })
          .catch((e) => {
            this.isLoading = false;
          });
      };

      this.confirm = function () {
        this.isLoading = true;
        this.account.foreignAccountId = this.accountId;
        this.account.isNew = this.newAccount;
        this.getUpdatedBill(this.selectedProductRatePlan, this.product.seats, 'first')
          .then((response) => {
            SubscriptionService.subscribe(
              response.bill[0].ratePlans,
              this.account,
              null,
              null,
              {},
              this.licenseId,
              this.subscription.PurchaseOrderNumber__c,
            ).then(() => {
              this.successRedirection = true;
            });
          })
          .catch((e) => {
            this.handleError(e);
          })
          .then(() => {
            setTimeout(function () {
              this.isLoading = false;
              $window.location.reload();
            }, 7500);
          });
      };
    },
  ]);
}
